export interface TypeConfig {
    name: string;
    detailPath: string;
    iconName: string;
}

export const HEIZUNG_CONFIG: TypeConfig = {
  name: 'Heizung',
  detailPath: '/heizung',
  iconName: 'heizung.png',
};

export const KALTWASSER_CONFIG: TypeConfig = {
  name: 'Kaltwasser',
  detailPath: '/kaltwasser',
  iconName: 'kaltwasser.png',
};

export const WARMWASSER_CONFIG: TypeConfig = {
  name: 'Warmwasser',
  detailPath: '/warmwasser',
  iconName: 'warmwasser.png',
};
